import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Field, FieldProps } from 'formik';
import { SelectProps } from '@radix-ui/react-select';
import { isInvalid } from '@/utils/isInvalid';
import { isNotNullish } from '@/utils/nullish';

export type ConnectedSelectOption = {
  label: React.ReactNode;
  value: any;
  disabled?: boolean;
};

export type ConnectedSelectProps = SelectProps & {
  id?: string;
  name: string;
  options: ConnectedSelectOption[];
  placeholder?: string;
  className?: string;
};

export const ConnectedSelect: React.FC<ConnectedSelectProps> = ({
  id,
  name,
  placeholder,
  options,
  className,
  ...props
}) => (
  <Field name={name}>
    {({ field, form }: FieldProps) => (
      <Select
        {...field}
        {...props}
        value={
          options?.length &&
          isNotNullish(field.value) &&
          options.some(
            (o) => JSON.stringify(o.value) === JSON.stringify(field.value)
          )
            ? JSON.stringify(field.value)
            : ''
        }
        onValueChange={(value) => {
          form.setFieldValue(
            field.name,
            options?.find((o) => JSON.stringify(o.value) === value)?.value
          );
          props.onValueChange?.(value);
        }}
      >
        <SelectTrigger
          id={id}
          aria-invalid={
            isInvalid(field.name, form.errors, form.touched) || undefined
          }
          className={className}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options?.map((p) => (
            <SelectItem
              key={JSON.stringify(p.value)}
              value={JSON.stringify(p.value)}
              disabled={p.disabled}
            >
              {p.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    )}
  </Field>
);
